/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IUpdateSuggestionMessage extends IMessage {
	id: string;
	documentId: string;
	hasComments?: boolean;
	isHasCommentsModified: boolean;
	state?: string;
	attributes: string;
}

export default class UpdateSuggestionMessage extends Message {
	public static readonly TYPE: string = '104';

	public static readonly READABLE_TYPE_NAME: string = 'updateSuggestion';

	public static readonly DESCRIPTOR_NAME: string = 'TrackChangesUpdateSuggestionMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				type: 'string',
				id: 1
			},
			documentId: {
				type: 'string',
				id: 2
			},
			hasComments: {
				type: 'bool',
				id: 3
			},
			isHasCommentsModified: {
				type: 'bool',
				id: 4
			},
			state: {
				type: 'string',
				id: 5
			},
			attributes: {
				type: 'string',
				id: 6
			}
		}
	};

	public constructor(
		public readonly id: string,
		public readonly documentId: string,
		public readonly hasComments: boolean | undefined,
		public readonly isHasCommentsModified: boolean,
		public readonly state?: string,
		public readonly attributes: Record<string, unknown> | null = null
	) {
		super();
	}

	public toJSON(): IUpdateSuggestionMessage {
		return {
			id: this.id,
			documentId: this.documentId,
			hasComments: this.hasComments,
			isHasCommentsModified: this.isHasCommentsModified,
			state: this.state,
			attributes: JSON.stringify( this.attributes )
		};
	}

	public static fromJSON( object: IUpdateSuggestionMessage ): UpdateSuggestionMessage {
		return new UpdateSuggestionMessage(
			object.id,
			object.documentId,
			object.hasComments,
			object.isHasCommentsModified,
			object.state,
			object.attributes ? JSON.parse( object.attributes ) : null
		);
	}
}
